export enum ButtonSubmitBlock {
  Root = 'ButtonSubmit',
}
